import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Item } from 'models/ItemModel';
import AsyncSelect from 'react-select/async';
import { Inventory } from 'models/InventoryModel';
import { CommonDataColumn } from 'models/BaseModel';
import { InventoryColumn } from 'constants/codes';
import { useSearchParams } from 'react-router-dom';


const ItemForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.ITEM, Code.Form.Name.ITEM];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Item>({});
  //const [selectedProduct, setSelectedProduct] = useState<OptionType | null>(null);
  const [localSkucode, setLocalSkucode] = useState<string>('');
  
  const [inventoryData, setInventoryData] = useState<CommonDataColumn>({});
  const [results, setResults] = useState<Inventory[]>([]);
  const [searchKey, setSearchKey] = useState('');

  const [searchParams] = useSearchParams();
  const Option1Id = searchParams.get(Code.UrlPara.Option1);
   
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(`${Code.File.ITEM}${Option1Id=="1" ? Code.File.PLUS : Code.File.MINUS}`, Code.Option.Common.SELECT, setStatusOptions, setError);
   
    //console.log("keyId", keyId);
   
    API.Data.GetByKeyId<Item>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.item_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  const getInventoryList = async (searchKey: string) => {
  
    if (searchKey.length<=2) {
      setResults([]);
      return;
    } 
    try {
      const url =  `${Code.Path.SERVER}inventory?search=${searchKey}&fields=inventory_id,product_id,inventory_sale_price,inventory_utncode,inventory_skucode,inventory_data,specification_id`; 
      const result = await API.Data.GetAll(url);
      const data: Inventory[] = result.data;

      if (Array.isArray(data)) {
        setResults(data);
      } else {
        setResults([]); 
      }

    } catch (error) {
      console.error('Error fetching search results:', error);
      setResults([]);  
    } 
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      item_skucode: value, 
    }));
    setSearchKey(value);
    getInventoryList(value);
  };

  const handleInventoryClick = async (event: React.MouseEvent<HTMLLIElement>, Data: Inventory) => {
      let Value = '';
      if(Data.inventory_skucode && Data.inventory_skucode !='') Value = Data.inventory_skucode;
      else if(Data.inventory_utncode && Data.inventory_utncode !='') Value = Data.inventory_utncode;
  
      setSearchKey(Value);
      const productName = await API.Data.GetProductName(Data.product_id);
      setFormData((prevData) => ({
        ...prevData,
        item_skucode: Value, 
        item_utncode: Data.inventory_utncode, 
        inventory_id: Data.inventory_id,
        product_id: Data.product_id,
        product_name: Utility.Value.Text(productName),
        item_price: Data.inventory_sale_price,
        item_quantity: 1,
      }));
  
      Files.List.ParseCommonData(Data.inventory_data, setInventoryData);
  
      if (!event.ctrlKey) {
        clearSearch(); 
      }
    };

  const clearSearch = () => {
    setResults([]);
    setSearchKey('');
  }

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Item"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
          
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Item.ItemStatusId} value={formData.item_status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,66,1]} require={true} />
                <Field.Date id={Name.Item.Date} value={formData.item_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]} require={true} currentDate={true} />
              </Control.Row>
              {/* <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product}>
                  <AsyncSelect id={Name.Product.Id} value={selectedProduct} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.SearchOption} onChange={(selected) => setSelectedProduct(selected as OptionType | null)} placeholder="Search" />
                </Field.Header>
              </Control.Row> */}
              <Control.Row>
                <Field.Text id={Name.Item.SKU} value={formData.item_skucode} title={Title.SkuUtn} onChange={(e) => handleSearchChange(e)} size={[0,66,1]} require={true} />
                <Field.Number id={Name.Item.Quantity} value={formData.item_quantity} title={Title.Quantity} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]} require={true} minValue={1} defaultValue={1} disabled={true} />
              </Control.Row>
              <Control.Row>
                {results.length > 0 && (
                  <div className='searchlist'>
                    <a onClick={() => clearSearch()}>×</a>
                    <ul>
                      <li className='fwb'>
                        <span className='form-col20'>UTN</span>
                        <span className='form-col30'>Brand</span>
                        <span className='form-col30'>Model</span>
                        <span className='form-col20'>SKU</span>
                      </li>
                      {results.map(result => (
                        <li key={result.inventory_id} onClick={(event) => handleInventoryClick(event, result)}>
                          <span className='form-col20'>{result.inventory_utncode}</span>
                          <span className='form-col30'>{Utility.Get.InvDataValue(result.inventory_data,result.specification_id,InventoryColumn.BRAND)}</span>
                          <span className='form-col30'>{Utility.Get.InvDataValue(result.inventory_data,result.specification_id,InventoryColumn.MODEL)}</span>
                          <span className='form-col20'>{result.inventory_skucode}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Item.Comment} value={formData.item_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} height={140} />
              </Control.Row>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default ItemForm;